import React, { useState } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import {
  Input,
  Checkbox,
  NumericTextBox,
  TextArea,
} from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import DefaultImage from "../../../assets/check_box.-default.png";
import SubmitButton from "components/common/SubmitButton";

const AddEditQuestion = (props) => {
  const IS_CLIENT = props.type === "Client";
  const [showUnknown, setShowUnknown] = useState(
    props.editItem?.unknownText ? true : false
  );
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const parseCommentsForString = (commentsForStr) => {
    const values = (commentsForStr || "")
      .split(",")
      .map((s) => s.trim().toLowerCase());

    return {
      commentsRequiredYes: values.includes("yes"),
      commentsRequiredNo: values.includes("no"),
      commentsRequiredCustom: values.includes("unknown"),
    };
  };
  const questionValidator = (value) => {
    if (!value?.trim()) {
      return "Question is required";
    }
    return "";
  };

  return (
    <Form
      onSubmit={props.onSubmit}
      initialValues={{
        ...props.editItem,
        ...(props.editItem
          ? parseCommentsForString(props.editItem?.commentsFor)
          : {
              commentsRequiredYes: true,
              commentsRequiredNo: true,
              commentsRequiredCustom: false,
            }),
      }}
      render={(formRenderProps) => (
        <FormElement
          style={{
            maxWidth: 1000,
          }}
        >
          <fieldset className={"k-form-fieldset"}>
            <div className="p-3 ps-5 pe-5">
              <Label className="label mt-2 mb-4">
                {IS_CLIENT ? "For Clients" : "For Matter"}
              </Label>
              <div className="mb-3 d-flex flex-column">
                <Label className="label mb-2">Question</Label>
                <Field
                  name="question"
                  component={TextArea}
                  validator={questionValidator}
                  placeholder={"Enter Question"}
                  style={{
                    maxWidth: "480px",
                    height: "120px",
                  }}
                />
                {submitAttempted && formRenderProps.errors?.question && (
                  <div className="fs-sm my-1 text-danger">
                    <i>{formRenderProps.errors.question}</i>
                  </div>
                )}
              </div>
              <div className="mb-3 d-flex align">
                <Label
                  className="label"
                  style={{
                    width: "150px",
                  }}
                >
                  Option
                </Label>
                <Label className="label">Weight</Label>
              </div>
              <div className="mb-3 d-flex">
                <div
                  className="d-flex align-items-center"
                  style={{
                    width: "150px",
                  }}
                >
                  <img height={"16px"} width={"16px"} src={DefaultImage}></img>
                  <Label className="label ms-3">Yes</Label>
                </div>
                <Field
                  name={"yesWeight"}
                  component={NumericTextBox}
                  spinners={false}
                  placeholder={"Enter Weight"}
                  style={{
                    width: "120px",
                    height: "32px",
                  }}
                />
              </div>
              <div className="mb-3 d-flex">
                <div
                  className="d-flex align-items-center"
                  style={{
                    width: "150px",
                  }}
                >
                  <img height={"16px"} width={"16px"} src={DefaultImage}></img>
                  <Label className="label ms-3">No</Label>
                </div>
                <Field
                  name={"noWeight"}
                  component={NumericTextBox}
                  spinners={false}
                  placeholder={"Enter Weight"}
                  style={{
                    width: "120px",
                    height: "32px",
                  }}
                />
              </div>
              <div className="mb-3 d-flex">
                <div
                  className="d-flex align-items-center"
                  style={{
                    width: "150px",
                  }}
                >
                  <Checkbox
                    value={showUnknown}
                    onChange={(e) => {
                      if (!e.value) {
                        formRenderProps.onChange("unknownText", { value: "" });
                      }
                      setShowUnknown(e.value);
                    }}
                    className="me-3 mt-2"
                  />
                  <Field
                    defaultChecked={true}
                    name={"unknownText"}
                    disabled={!showUnknown}
                    component={Input}
                    style={{
                      width: "110px",
                      height: "32px",
                    }}
                    placeHolder={"Enter Text"}
                  />
                </div>
                <Field
                  name={"unknownWeight"}
                  component={NumericTextBox}
                  spinners={false}
                  placeholder={"Enter Weight"}
                  disabled={!showUnknown}
                  style={{
                    width: "120px",
                    height: "32px",
                  }}
                />
              </div>
              {/* <div className="mt-4">
                <Label className="label mb-2">Comments Required</Label>
                <div className="d-flex gap-5 mt-3">
                  <Field
                    name="commentsRequiredYes"
                    type="checkbox"
                    component={Checkbox}
                    defaultChecked
                    className="label"
                    label="Yes"
                  />
                  <Field
                    name="commentsRequiredNo"
                    type="checkbox"
                    defaultChecked
                    component={Checkbox}
                    className="label"
                    label="No"
                  />
                  {showUnknown && (
                    <Field
                      name="commentsRequiredCustom"
                      type="checkbox"
                       className="label"
                      defaultChecked
                      component={Checkbox}
                      label={formRenderProps.valueGetter("unknownText") || 'Unknown Text'}
                    />
                  )}
                </div>
              </div> */}
            </div>
            <div className="dialog-footer">
              <button
                className="common-btn bgBtnSecondary me-1"
                onClick={props.onClose}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-2"
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
                isLoading={props.isSubmitting}
              >
                {IS_CLIENT ? "Update" : "Save"}
              </SubmitButton>
            </div>
          </fieldset>
        </FormElement>
      )}
    />
    // </div>
  );
};

export default AddEditQuestion;
